/**
 * @description axios 网络请求封装
 * @author chenzhong
 */
 
import axios from 'axios'
import { Message } from 'element-ui'
let querystring = require('querystring')
 
//环境的切换
if (process.env.NODE_ENV == 'development') { 
  axios.defaults.baseURL = '';
}else if (process.env.NODE_ENV == 'production') { 
   axios.defaults.baseURL = '';
}
axios.defaults.timeout = 10000 // 超时时长
axios.defaults.withCredentials = true // 携带cookie
// 这样设置无效，需要在拦截器中设置
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
 
axios.interceptors.request.use(config => {
  let _token = localStorage.getItem("_token")
  if(_token != undefined && _token != ""){
    config.headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      "session_token":_token
    }
  }else{
    config.headers = {
      'Content-Type': 'application/json;charset=UTF-8',
    }
  }

  return config
}, err => {
    return Promise.reject(err)
})
 
axios.interceptors.response.use(response => {
  if(JSON.stringify(response.data).indexOf("操作异常！") > 0){
      Message({
        message: "登陆过期，请重新登陆",
        type: 'error'
      });
      localStorage.setItem('_token', "");
      localStorage.setItem('_id', "");
      localStorage.setItem('_userName', "");
      location.href = '#/login'
      return false;
  }
  return response
}, err => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        error.message = '错误请求'
        break;
      case 401:
        error.message = '未授权，请重新登录'
        break;
      case 403:
        error.message = '拒绝访问'
        break;
      case 404:
        error.message = '请求错误,未找到该资源'
        break;
      case 405:
        error.message = '请求方法未允许'
        break;
      case 408:
        error.message = '请求超时'
        break;
      case 500:
        err.message = '服务器端出错'
        break;
      case 501:
        error.message = '网络未实现'
        break;
      case 502:
        error.message = '网络错误'
        break;
      case 503:
        error.message = '服务不可用'
        break;
      case 504:
        error.message = '网络超时'
        break;
      case 505:
        error.message = 'http版本不支持该请求'
        break;
      default:
        error.message = `连接错误${err.response.status}`
    }
  }else {
    err.message = "连接到服务器失败"
  }
  return Promise.reject(err)
})
 
/**
 * get请求
 * @param {string} url 请求url
 * @param {Object} data 请求参数
 */


 
export function get (url, data = {}) {
  return axios.get(url, {params: data})
}
 
/**
 * post请求
 * @param {string} url 请求url
 * @param {Object} data 请求参数
 */
export function post (url, data = {}) {
  return axios.post(url, querystring.stringify(data))
}
 
/**
 * post请求
 * @param {string} url 请求url
 * @param {Object} data 请求参数
 */
export function postWithJson (url, data = {}) {
  return axios.post(url, data)
}
 
/**
 * post form参数请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export function form (url, data = {}) {
  return axios.post(url,
    querystring.stringify(data),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    }
  )
}




/**
 * 测试列表
 * @param {string} params.name
 * @param {Object} params.pageDto
 *
 * @returns {Promise}
 */
//import {get, post} from '@/api/services'
// export function tagList (params) {
//   return get('/user/list', params)
// }


// WEBPACK FOOTER //
// ./src/api/services.js